import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "example fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex my-auto"
}
const _hoisted_2 = { class: "relative w-full lg:w-3/5 my-6 mx-2 lg:mx-auto container" }
const _hoisted_3 = { class: "border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none" }
const _hoisted_4 = { class: "flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "text-3xl font-semibold" }, "การยืนยันรายการ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none" }, " × ", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-md p-6 mx-4 my-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-lg mb-4" }, " คุณต้องการยืนยันข้อมูลการจัดส่งใช่หรือไม่ ? ")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "flex flex-col gap-4 fixed top-5 right-5 w-3/5 lg:w-2/5 xl:w-1/5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center w-12 bg-red-500" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-6 h-6 text-white fill-current",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M20 3.36667C10.8167 3.36667 3.3667 10.8167 3.3667 20C3.3667 29.1833 10.8167 36.6333 20 36.6333C29.1834 36.6333 36.6334 29.1833 36.6334 20C36.6334 10.8167 29.1834 3.36667 20 3.36667ZM19.1334 33.3333V22.9H13.3334L21.6667 6.66667V17.1H27.25L19.1334 33.3333Z" })
  ])
], -1)
const _hoisted_15 = { class: "px-4 py-2 -mx-3" }
const _hoisted_16 = { class: "mx-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-red-500 dark:text-red-400" }, "Fail", -1)
const _hoisted_18 = { class: "text-sm text-gray-600 dark:text-gray-200" }
const _hoisted_19 = {
  key: 1,
  class: "opacity-25 fixed inset-0 z-40 bg-black"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  class: "p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal()))
                }, _hoisted_7)
              ]),
              (_ctx.data)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "text-green-island-500 bg-gray-200 hover:bg-gray-300 active:bg-gray-300 font-bold uppercase text-sm px-6 py-3 rounded outline-none focus:outline-none mr-4 mb-1 ease-linear transition-all duration-150",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleModal()))
                }, " ยกเลิก "),
                _createElementVNode("button", {
                  class: _normalizeClass(["text-gray-200 rounded-md bg-green-island-500 hover:bg-green-island-600 background-transparent font-bold uppercase px-6 py-3 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150", _ctx.saveDisabled ? 'opacity-25' : '']),
                  type: "button",
                  disabled: _ctx.saveDisabled,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.btnOkClick()))
                }, " ยืนยัน ", 10, _hoisted_12)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogErrorArr, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.text,
                  class: "flex w-full max-w-sm overflow-hidden bg-white rounded-lg shadow-md z-20 dark:bg-gray-800"
                }, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("p", _hoisted_18, _toDisplayString(item.text), 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19))
      : _createCommentVNode("", true)
  ]))
}